const AUTH_CALLBACK_PATHS = ['/auth-callback', '/logout-callback', '/silent-renew'] as const;

export function isValidReturnUrl(url: unknown): url is string {
  if (typeof url !== 'string') return false;
  if (!url.startsWith('/')) return false;

  // Reject protocol-relative URLs (e.g. //evil.com)
  if (url.startsWith('//')) return false;

  // Extract pathname (before any query string) for route checking
  const pathname = url.split('?')[0];

  // Reject auth callback routes to prevent redirect loops
  return !AUTH_CALLBACK_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
}
